import { HTMLAttributes, PropsWithChildren } from "react";

export enum DisplayType {
    EXTRA_SMALL,
    SMALL,
    MEDIUM,
    LARGE,
    EXTRA_LARGE
}

export enum ContainerTye {
    div,
    aside,
    span
}
export type ContainerProps = {
    type?: ContainerTye,
    condition?: (isMobile: boolean, displayType: DisplayType) => boolean
} & PropsWithChildren<HTMLAttributes<any>>

export type ContextDisplayData = {
    displayType: DisplayType,
    isMobile: boolean

}